import { Modal } from "react-bootstrap";
import styled from "styled-components";

const StyledModal = styled(Modal)`
  .modal-dialog {
    width: 449px;
    max-width: calc(100% - 32px);
    margin-left: auto;
    margin-right: auto;
  }

  .modal-content {
    border: none;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    overflow: hidden;
  }

  .modal-body {
    padding: 0;
  }
`;

const ModalContent = styled.div`
  width: 100%;
  min-height: ${({ $minHeight }) => $minHeight};
  padding: ${({ $padding }) => $padding};
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;

  text-align: center;
`;

function LikesAlertModal({
  show,
  close,
  content,
  padding = "24px",
  minHeight = "122px",
}) {
  return (
    <StyledModal
      show={show}
      onHide={close}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        <ModalContent
          $padding={padding}
          $minHeight={minHeight}
        >
          {content}
        </ModalContent>
      </Modal.Body>
    </StyledModal>
  );
}

export default LikesAlertModal;